import { defineMessages } from 'react-intl';

/** Trial-recap variant copy for the Practice upgrade modal (react-intl; not in common.json). */
export const practiceUpgradeRecapMessages = defineMessages({
  title: {
    defaultMessage:
      '{daysLeft, plural, one {# day} other {# days}} of complimentary Evidence features remaining',
    id: '/Bpw5gfya4',
    description:
      '90-day trial Practice upgrade modal heading; days remaining on complimentary Evidence',
  },
  subtitle: {
    defaultMessage:
      "Do nothing and you'll return to <link>Scribe Team</link>, (formerly called Practice). No billing changes.",
    id: 'enqceLu4m3',
    description:
      "Subtitle under the 90-day trial Practice upgrade modal: downgrade outcome; 'Scribe Team' links to the plan-changes help article",
  },
  subtitleNonAdminTeam: {
    defaultMessage:
      "If your admin does nothing you'll return to <link>Scribe Team</link>, (formerly called Practice). No billing changes.",
    id: 'utJP8HPgfA',
    description:
      "90-day trial Practice upgrade modal subtitle for non-admins on a team: admin inaction and downgrade outcome; 'Scribe Team' links to the plan-changes help article",
  },
  upgradeCta: {
    defaultMessage: 'Upgrade to the new Practice plan',
    id: '4Tn5H5GZp5',
    description:
      'Primary button on the 90-day trial Practice upgrade modal; upgrades to the new Practice plan',
  },
  upgradingTitle: {
    defaultMessage: "You're upgrading to Practice",
    id: 'co85e9eG7D',
    description:
      'Heading on the Practice upgrade modal when opened from the post-90-day trial-ended recap',
  },
  titleNinetyDayTrialEnded: {
    defaultMessage: 'Clinical answers for your team, in every consult',
    id: 'TivG7XJVYR',
    description:
      'Heading on the Practice upgrade modal for users whose 90-day reverse trial has ended',
  },
  subtitleNinetyDayTrialEnded: {
    defaultMessage: 'Practice puts live Evidence beside the note',
    id: 'bt7AK6c2WI',
    description:
      'Subtitle on the Practice upgrade modal for users whose 90-day reverse trial has ended',
  },
});
